import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5068/api';

export interface AppConfig {
  title: string;
  clientName: string;
}

const DEFAULT_CONFIG: AppConfig = {
  title: 'GraveSearch',
  clientName: 'GraveSearch',
};

export async function fetchAppConfig(): Promise<AppConfig> {
  try {
    const response = await axios.get<AppConfig>(`${API_BASE_URL}/config`);
    return response.data;
  } catch {
    return DEFAULT_CONFIG;
  }
}
